module.exports = __webpack_public_path__ + "static/media/canada8.e1a45718.jpg";